import React from 'react';
import { Nav } from '@catalogo/core-nav';

export const SimilarLink = ({ similarUrl, children, onClick }) => {
  if (!similarUrl) {
    return null;
  }

  return (
    <Nav to={similarUrl} onClick={onClick}>
      {children}
    </Nav>
  );
};
